/**
 * @generated SignedSource<<33d79a1a7af287ef884fad565c4d6f7b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CastRowQuery$variables = Record<PropertyKey, never>;
export type CastRowQuery$data = {
  readonly characters: ReadonlyArray<{
    readonly accentHex: string;
    readonly artKey: string;
    readonly audience: string;
    readonly id: string;
    readonly intensity: number;
  }>;
};
export type CastRowQuery = {
  response: CastRowQuery$data;
  variables: CastRowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Character",
    "kind": "LinkedField",
    "name": "characters",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "audience",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "artKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accentHex",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "intensity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CastRowQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CastRowQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "868c1c17c0dd7153711770a010b15f3e",
    "id": null,
    "metadata": {},
    "name": "CastRowQuery",
    "operationKind": "query",
    "text": "query CastRowQuery {\n  characters {\n    id\n    audience\n    artKey\n    accentHex\n    intensity\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6507c57ce314bcf90c28f7761cf0f1b";

export default node;
